import request from '@/plugin/axios'

export function createCoupon (data) {
  return request({
    url: '/api/admin/createCoupon',
    method: 'post',
    data: data
  })
}
export function distributionCoupon (data) {
  return request({
    url: '/api/admin/distributionCoupon',
    method: 'post',
    data: data
  })
}
export function couponRecords (data) {
  return request({
    url: '/api/admin/queryGetCouponRecordByPage',
    method: 'get',
    params: data
  })
}
export function couponCategorys (data) {
  return request({
    url: '/api/admin/queryCouponCategoryByPage',
    method: 'get',
    params: data
  })
}
export function couponCategoryOptions (data) {
  return request({
    url: '/api/admin/loadCategoryList',
    method: 'get',
    params: data
  })
}
export function couponDetailRecords (data) {
  return request({
    url: '/api/admin/queryGetCouponListByPage',
    method: 'get',
    params: data
  })
}
export function writeOffCoupon (data) {
  return request({
    url: '/api/admin/writeOffCoupon',
    method: 'post',
    data: data
  })
}
export function delCouponState (data) {
  return request({
    url: '/api/admin/voidCoupons',
    method: 'get',
    params: data
  })
}
export function couponMakePaper (data) {
  return request({
    url: '/api/admin/update_is_make_paper',
    method: 'post',
    data: data
  })
}
export function queryChildOrgCouponStatistics (data) {
  return request({
    url: '/api/admin/queryChildOrgCouponStatistics',
    method: 'get',
    params: data
  })
}
export function queryChildOrgCardStatistics (data) {
  return request({
    url: '/api/admin/queryChildOrgCardStatistics',
    method: 'get',
    params: data
  })
}
export function writeOffCouponAndCardStatistics (data) {
  return request({
    url: '/api/admin/writeOffCouponAndCardStatistics',
    method: 'get',
    params: data
  })
}
export function queryCouponDetailOfDiscountForm (data) {
  return request({
    url: '/api/admin/queryCouponDetailOfDiscountForm',
    method: 'get',
    params: data
  })
}
export function queryCouponByNo (data) {
  return request({
    url: '/api/user/createCoupon',
    method: 'post',
    data: data
  })
}

export function queryWriteOffRecordByPage (data) {
  return request({
    url: '/api/admin/queryWriteOffRecordByPage',
    method: 'get',
    params: data
  })
}
export function queryWriteOffDetail (data) {
  return request({
    url: '/api/admin/queryWriteOffDetail',
    method: 'get',
    params: data
  })
}
// 新增券类型
export function addCouponCategory (data) {
  return request({
    url: '/api/admin/addCouponCategory',
    method: 'post',
    data: data
  })
}
// 授权
export function doGrant (data) {
  return request({
    url: '/api/admin/doGrant',
    method: 'post',
    data: data
  })
}
// 授权审核
export function doGrantCheck (data) {
  return request({
    url: '/api/admin/doGrantCheck',
    method: 'post',
    data: data
  })
}
// 审核记录分页
export function couponApprovateListByPage (data) {
  return request({
    url: '/api/admin/couponApprovateListByPage',
    method: 'get',
    params: data
  })
}
// 原路退回
export function doBackOff (data) {
  return request({
    url: '/api/admin/doBackOff',
    method: 'post',
    data: data
  })
}
// 套餐分页列表
export function queryOrgCouponCodeByPage (data) {
  return request({
    url: '/api/admin/queryOrgCouponCodeByPage',
    method: 'get',
    params: data
  })
}
// 查询可选择的券包
export function queryCanComposeCouponRecordList (data) {
  return request({
    url: '/api/admin/queryCanComposeCouponRecordList',
    method: 'get',
    params: data
  })
}
// 新增套餐
export function createCouponCode (data) {
  return request({
    url: '/api/admin/createCouponCode',
    method: 'post',
    data: data
  })
}
// 查询某机构券类型列表
export function queryCouponCategories (data) {
  return request({
    url: '/api/admin/queryCouponCategories',
    method: 'get',
    params: data
  })
}
// 套餐详情
export function queryCouponCodeDetailById (data) {
  return request({
    url: '/api/admin/queryCouponCodeDetailById',
    method: 'get',
    params: data
  })
}
// 同步至领券页
export function synchCouponCodeToH5Get (data) {
  return request({
    url: '/api/admin/synchCouponCodeToH5Get',
    method: 'post',
    data: data
  })
}
// 取消同步
export function pullOffCouponCode (data) {
  return request({
    url: '/api/admin/pullOffCouponCode',
    method: 'post',
    data: data
  })
}
// 同步/取消同步 至商城
export function syncToShop (data) {
  return request({
    url: '/api/admin/syncToShop',
    method: 'post',
    data: data
  })
}
// 套餐作废
export function voidCouponCode (data) {
  return request({
    url: '/api/admin/voidCouponCode',
    method: 'post',
    data: data
  })
}
// 套餐领取记录
export function queryReceiveRecordOfCouponCodeByPage (data) {
  return request({
    url: '/api/admin/queryReceiveRecordOfCouponCodeByPage',
    method: 'get',
    params: data
  })
}

export function queryEmpowerOrgStatisticsByPage (data) {
  return request({
    url: '/api/admin/queryEmpowerOrgStatisticsByPage',
    method: 'get',
    params: data
  })
}
export function queryEmpowerOrgStatisticsDetailByPage (data) {
  return request({
    url: '/api/admin/queryEmpowerOrgStatisticsDetailByPage',
    method: 'get',
    params: data
  })
}
export function queryCouponCodeSynchRecordListByPage (data) {
  return request({
    url: '/api/admin/queryCouponCodeSynchRecordListByPage',
    method: 'get',
    params: data
  })
}
export function approvateSynchApply (data) {
  return request({
    url: '/api/admin/approvateSynchApply',
    method: 'post',
    data: data
  })
}
export function queryCouponTypeByPage (data) {
  return request({
    url: '/api/admin/queryCouponTypeByPage',
    method: 'get',
    params: data
  })
}
export function createCouponType (data) {
  return request({
    url: '/api/admin/createCouponType',
    method: 'post',
    data: data
  })
}
export function queryCouponTypeList () {
  return request({
    url: '/api/admin/queryCouponTypeList',
    method: 'get'
  })
}

export function drawBackCouponCode (data) {
  return request({
    url: '/api/admin/drawBackCouponCode',
    method: 'post',
    data: data
  })
}
export function queryCouponCodeOption (data) {
  return request({
    url: '/api/admin/queryCouponCodeOption',
    method: 'get',
    params: data
  })
}
export function queryOrgCouponCodeForSelect (data) {
  return request({
    url: '/api/admin/queryOrgCouponCodeForSelect',
    method: 'get',
    params: data
  })
}
